import React from "react";
import '../css/LegalPages.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Privatlivspolitik</h1>
      <p>
        Hos Linx Legacy Academy tager vi dit privatliv alvorligt. Vi behandler dine personoplysninger 
        i overensstemmelse med gældende lovgivning (GDPR).
      </p>

      <h2>Hvilke oplysninger indsamler vi?</h2>
      <ul>
        <li>Navn, e-mail, telefonnummer og in-game navn</li>
        <li>Discord ID</li>
        <li>Hold- og træningstider</li>
        <li>Betalingsinformation (via Stripe, kun pris-id og kvittering – vi håndterer ikke kortdata)</li>
        <li>Brugsdata og cookies (fx Google Analytics)</li>
      </ul>

      <h2>Formål med behandling</h2>
      <p>Dine data bruges til:</p>
      <ul>
        <li>Administration af brugerprofil og holdtræning</li>
        <li>Kommunikation om træning, events og medlemskab</li>
        <li>Håndtering af betalinger via Stripe</li>
        <li>Statistik og forbedring af vores services via Google Analytics</li>
      </ul>

      <h2>Deling af oplysninger</h2>
      <p>Dine oplysninger deles kun med:</p>
      <ul>
        <li>Stripe (betaling og kvittering)</li>
        <li>Trænere og interne medarbejdere med behov for info om hold/træning</li>
        <li>Google Analytics (anonymiseret IP til statistik)</li>
      </ul>

      <h2>Opbevaringsperiode</h2>
      <p>
        Vi opbevarer dine oplysninger så længe du er medlem, og op til 6 måneder efter eventuel ophør 
        for dokumentation af betaling og træning.
      </p>

      <h2>Rettigheder</h2>
      <p>Du har altid ret til:</p>
      <ul>
        <li>Indsigt i dine oplysninger</li>
        <li>At få rettet eller slettet oplysninger</li>
        <li>Dataportabilitet</li>
        <li>At trække dit samtykke tilbage</li>
      </ul>

      <h2>Kontakt</h2>
      <p>
        Har du spørgsmål, eller vil du bruge dine rettigheder, kan du kontakte os på 
        <a href="mailto:Academy@linxlegacy.dk"> Academy@linxlegacy.dk</a>.
      </p>
    </div>
  );
}